import { render } from "./ViewVehicles.vue?vue&type=template&id=6870d9a9"
import script from "./ViewVehicles.vue?vue&type=script&lang=js"
export * from "./ViewVehicles.vue?vue&type=script&lang=js"

import "./ViewVehicles.vue?vue&type=style&index=0&id=6870d9a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__